/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deposit_Error_Amount_Below_Network_FeesInputs */

const en_deposit_error_amount_below_network_fees = /** @type {(inputs: Deposit_Error_Amount_Below_Network_FeesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This amount is too small to cover network fees.`)
};

const de_deposit_error_amount_below_network_fees = /** @type {(inputs: Deposit_Error_Amount_Below_Network_FeesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Betrag ist zu klein, um die Netzwerkgebühren zu decken.`)
};

const pt_br2_deposit_error_amount_below_network_fees = /** @type {(inputs: Deposit_Error_Amount_Below_Network_FeesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este valor é muito baixo para cobrir as taxas de rede.`)
};

const tr_deposit_error_amount_below_network_fees = /** @type {(inputs: Deposit_Error_Amount_Below_Network_FeesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu tutar ağ ücretlerini karşılamak için çok küçük.`)
};

const zh_cn2_deposit_error_amount_below_network_fees = /** @type {(inputs: Deposit_Error_Amount_Below_Network_FeesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该金额太小，不足以支付网络费用。`)
};

const zh_hk2_deposit_error_amount_below_network_fees = /** @type {(inputs: Deposit_Error_Amount_Below_Network_FeesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此金額太少，不足以支付網絡費用。`)
};

const ko_kr2_deposit_error_amount_below_network_fees = /** @type {(inputs: Deposit_Error_Amount_Below_Network_FeesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 금액은 네트워크 수수료를 충당하기에 너무 적습니다.`)
};

const ru_ru2_deposit_error_amount_below_network_fees = /** @type {(inputs: Deposit_Error_Amount_Below_Network_FeesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эта сумма слишком мала, чтобы покрыть комиссию сети.`)
};

const es_419_deposit_error_amount_below_network_fees = /** @type {(inputs: Deposit_Error_Amount_Below_Network_FeesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este monto es demasiado pequeño para cubrir las comisiones de red.`)
};

/**
* | output |
* | --- |
* | "This amount is too small to cover network fees." |
*
* @param {Deposit_Error_Amount_Below_Network_FeesInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const deposit_error_amount_below_network_fees = /** @type {((inputs?: Deposit_Error_Amount_Below_Network_FeesInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deposit_Error_Amount_Below_Network_FeesInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deposit_error_amount_below_network_fees(inputs)
	if (locale === "de") return de_deposit_error_amount_below_network_fees(inputs)
	if (locale === "pt-BR") return pt_br2_deposit_error_amount_below_network_fees(inputs)
	if (locale === "tr") return tr_deposit_error_amount_below_network_fees(inputs)
	if (locale === "zh-CN") return zh_cn2_deposit_error_amount_below_network_fees(inputs)
	if (locale === "zh-HK") return zh_hk2_deposit_error_amount_below_network_fees(inputs)
	if (locale === "ko-KR") return ko_kr2_deposit_error_amount_below_network_fees(inputs)
	if (locale === "ru-RU") return ru_ru2_deposit_error_amount_below_network_fees(inputs)
	return es_419_deposit_error_amount_below_network_fees(inputs)
});